
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PROJECT_MANAGEMENT_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root'
})
export class CurrencyRateService {
    private readonly baseUrl = `${PROJECT_MANAGEMENT_URL}/currency-rate`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    getAll(): Observable<any[]> {
        return this.http.get<any[]>(`${this.baseUrl}/getAll`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    getCurrencies(): Observable<string[]> {
        return this.http.get<string[]>(`${this.baseUrl}/getCurrencies`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    getConversionRate(source: string, target: string): Observable<{ rate: number }> {
        const params = new HttpParams()
            .set('source', source)
            .set('target', target);

        return this.http.get<{ rate: number }>(`${this.baseUrl}/getConversionRate`, { params })
            .pipe(catchError(this.errorHandler.handleError));
    }
}
